<script setup lang="ts">
import BannerComponent from '@/components/BannerComponent.vue'
import GAVForm from '@/components/GAVForm.vue'
import LohnEntwicklungComponent from '@/components/LohnEntwicklungComponent.vue'
import LohnrechnerResult from '@/components/LohnrechnerResult.vue'
import ShareResult from '@/components/ShareResult.vue'
import { useResultStore } from '@/stores/lohndaten'
import { inject } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'

function setStyles() {
  document.body.classList.add('transition')
}

function resetStyles() {
  document.body.style.setProperty('--color-background', '#fff')
  document.body.style.setProperty('--color-text', '#34333C')
  document.body.style.setProperty('--color-grey', '#f9f1f1')
  document.body.classList.remove('transition')
}

const resultStore = useResultStore()

const router = useRouter()

onMounted(() => {
  if (!resultStore.request.beruf) {
    router.push('/')
  }
  setStyles()
})

onUnmounted(() => {
  resetStyles()
})

function scrollToTop() {
  setTimeout(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    resultForm.value.goToStep(1)
  }, 800)
}

const resultForm = ref(null)

const setTitle = inject('setTitle')
const showYearly = ref(false)
const factor = ref(1)

function update(e, f) {
  showYearly.value = e
  factor.value = f

}

setTitle('lohn-resultat')
</script>

<template>
  <div class="result" v-if="resultStore.request.beruf">
    <LohnrechnerResult ref="resultForm" @show-yearly="update"></LohnrechnerResult>
  </div>

  <GAVForm @complete="scrollToTop" v-if="resultStore.request.beruf"></GAVForm>

  <ShareResult v-if="resultStore.request.beruf"></ShareResult>
  <BannerComponent :industry="resultStore.request.branche.pk" :region="resultStore.request.plz.region.pk"
    v-if="resultStore.request"></BannerComponent>


  <LohnEntwicklungComponent :show-yearly="showYearly" :factor="factor"></LohnEntwicklungComponent>

</template>

<style scoped></style>

<style>
body.transition header {
  --color-background: #34333c;
  --color-text: #f9f1f1;
}

body.transition .result {
  --color-background: #34333c;
  --color-text: #f9f1f1;

  color: var(--color-text);
  margin-left: calc(-1 * var(--container-padding) / 2);
  margin-right: calc(-1 * var(--container-padding) / 2);

  --max-result-width: calc(min(98vw, var(--frame-width)) - 20px);
  --container-result-padding: calc(100vw - var(--max-result-width));
  padding-left: calc(var(--container-result-padding) / 2);
  padding-right: calc(var(--container-result-padding) / 2);
  padding-top: 50px;

  border-radius: 0 0 14px 14px;
  box-shadow: rgba(0, 0, 0, 0.25) 0 4px 4px 0;

  background: linear-gradient(180deg,
      #ffffff,
      var(--color-background) 50%,
      var(--color-background));
  background-size: 400% 400%;

  -webkit-animation: fadeInBackground 1.2s ease-in 1;
  -moz-animation: fadeInBackground 1.2s ease-in 1;
  animation: fadeInBackground 1.2s ease-in 1;
  animation-fill-mode: forwards;
}

@-webkit-keyframes fadeInBackground {
  0% {
    background-position: 50% 0%;
  }

  100% {
    background-position: 99% 100%;
  }
}

@-moz-keyframes fadeInBackground {
  0% {
    background-position: 50% 0%;
  }

  100% {
    background-position: 99% 100%;
  }
}

@keyframes fadeInBackground {
  0% {
    background-position: 50% 0%;
  }

  100% {
    background-position: 99% 100%;
  }
}
</style>

<style>
#gavForm .vf-btn {
  background-color: transparent !important;
  border: none !important;
}

#gavForm .vf-btn svg {
  stroke: #858585;
}

#gavForm .vf-btn.vf-btn-disabled svg {
  stroke: #afaeae;
}

#gavForm .vf-multiselect-wrapper,
#gavForm .vf-multiselect-option {
  background-color: white;
  margin-top: 0;
}

#gavForm .vf-multiselect-option:hover {
  background-color: #e6d9d9;
}

#gavForm .vf-multiselect-dropdown {
  background-color: white !important;
  border-top: solid white 5px !important;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 3px;
  border-bottom: solid white 5px !important;
}

#gavForm .vf-multiselect-option.vf-multiselect-option-selected {
  background-color: #f9f1f1;
  color: var(--color-text) !important;
}

@media screen {
  .printer-only {
    display: none !important;
  }
}

@media print {
  .no-print {
    display: none !important;
  }

  nav.top,
  .buttons-wrapper,
  .buttons,
  .control-wrapper,
  .result-hint,
  .gav-info,
  #gavForm,
  #gav-accordions,
  footer {
    display: none !important;
  }

  main {
    margin-top: -40px;
  }

  table td,
  table th {
    padding: 5px;
    color: #34333c;
  }

  .printer-only,
  #selected {
    color: #34333c;
  }

  main,
  .result {
    padding: 0;
    box-shadow: none !important;
  }

  header svg {
    position: fixed;
    top: 0;
    right: 0;
    --color-text: #34333c;
  }

  #info-0 {
    left: 1% !important;
  }

  #info-1 {
    left: 1% !important;
  }
}
</style>
